<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6oHvis/tc-custom/9781453290538.jpg?1726755912691" alt="This image is the cover for the book Trouble Follows Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trouble Follows Me
      </h1>
      <p class="bookDescription body article font2">
        <b>In the last days of World War II, a sailor discovers a transcontinental conspiracy in this classic from “the greatest mystery novelist of his age” (John Connolly, author of<i> Every Dead Thing</i>).</b><br/>  It is February 1945, and the war in the Pacific is nearing its climax. In Hawaii on his way to a new post, US Navy ensign Sam Drake stumbles across the girl of his dreams. Mary is a disc jockey, with a voice that’s famous across the islands for playing late-night jazz that no young lover can resist. Before he can follow this modern siren home, they go to check on Mary’s coworker Sue—but that lovely young lady will never spin another record. They find her strung up and dangling outside the window of a bathroom, her face twisted into an ugly mask. The police call it suicide, but Sam is not so sure. Few beautiful women, even suicidal ones, are willing to be so hideous in death. Looking into Sue’s past, he finds another corpse—and a dangerous conspiracy that stretches all the way back to his Motor City home.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ross Macdonald
      </h2>
      
      <p class="authorDescription body article">Ross Macdonald was a pseudonym for Kenneth Millar (1915&ndash;1983), an author of detective fiction best known for creating the character of Lew Archer, a California PI. Born in California, Millar lived in Ontario, Canada, until his father abandoned his mother, uprooting the family and forcing them to move again and again over the next few years&mdash;a formative experience that would often be echoed in Millar&rsquo;s work. While attending the University of Michigan, Millar began writing pulp fiction, publishing his first novel, <i>The Dark Tunnel</i>, in 1944.&#160;Millar introduced Lew Archer, the tough-but-sensitive private detective, in the 1946 short story &ldquo;Find the Woman.&rdquo; <i>The Moving Target</i> (1949) was the first of more than a dozen Lew Archer novels, which established Millar as one of the finest crime novelists of his day. He is often included in the &ldquo;holy trinity of detective fiction,&rdquo; along with Dashiell Hammett and Raymond Chandler.&#160;&#160; &#160;&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9b9984d6